import React from 'react';
import { useStyles } from '@wix/tpa-settings/react';
import styleParams from '../../../../components/CategoryMenu/stylesParams';
import { useSelector } from '../../../common/components/runtime-context';
import { getCategoryMenuWidgetData } from '../../aggregated-category-menu/selectors';
import LinkList from '../link-list-new';
import LinkText from '../link-text';

const CategoryMenuNew = () => {
  const styles = useStyles();

  const categoryMenuWidgetData = useSelector(getCategoryMenuWidgetData);
  const links = React.useMemo(() => {
    const { categoryMenu } = categoryMenuWidgetData;

    return categoryMenu.map((category) => ({
      key: category.id,
      path: category.path,
      text: (
        <LinkText
          postCount={category.display.postCount}
          a11yText={category.display.a11yText}
        >
          {category.display.text}
        </LinkText>
      ),
    }));
  }, [categoryMenuWidgetData]);

  return (
    <nav aria-label={categoryMenuWidgetData.areaLabel}>
      <LinkList
        links={links}
        emptyState={{ text: categoryMenuWidgetData.emptyState }}
        alignment={styles.get(styleParams.textAlignmentV2)}
      />
    </nav>
  );
};

export default CategoryMenuNew;
